<template>
  <div class="row">
    <div class="col-12">
      <Heading>
        {{ customer.name }}
      </Heading>
      <div class="border border-light p-5">

        <div class="row">

          <div class="col-12 mb-4">
            <b class="text-primary">Name:</b><br>
            <data-input v-model.trim="customer.name"/>

          </div>
          <div class="col-6 mb-4">
            <b class="text-primary">Kundenummer:</b><br>
            <data-input v-model.trim="customer.customer_number"/>

          </div>
          <div class="col-6">
            <b class="text-primary">E-Mail Adresse:</b><br>
            <data-input type="email"
                        placeholder="E-Mail Adresse"
                        v-model.trim="customer.email"
            />
          </div>

          <div class="col-6">
            <b class="text-primary">Standort:</b><br>
            <data-input placeholder="Straße" v-model.trim="customer.address"/>
            <div class="row">
              <div class="col pr-1">
                <data-input placeholder="PLZ" v-model.trim="customer.postal"/>
              </div>
              <div class="col-7 pl-0">
                <data-input placeholder="Stadt" v-model.trim="customer.city"/>
              </div>
            </div>
          </div>
          <div class="col-6">
            <b class="text-primary">Telefonnummer:</b><br>

            <data-input type="tel"
                        placeholder="Telefonnummer"
                        v-model.trim="customer.phone"
            />
            <data-input type="tel"
                        placeholder="Faxnummer"
                        v-model.trim="customer.fax"
            />
          </div>

          <div class="col-3 offset-6 text-right">
            <button @click="cancel" class="btn btn-secondary btn-block mt-5 btn-sm">Abbrechen</button>
          </div>
          <div class="col-3 text-right">
            <button @click="save" class="btn btn-primary btn-block mt-5 btn-sm">Speichern</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Heading from "../../components/admin/Heading";
import {mapActions} from "vuex";
import BottleState from "../../components/admin/BottleState";
import List from "../../components/admin/List";
import timeFormatter from "../../mixins/timeFormatter";
import DataSelect from "../../components/DataSelect";
import DataInput from "../../components/DataInput";

export default {
  name: "CustomerAdd",
  components: {DataInput, DataSelect, Heading, BottleState, List},
  mixins: [timeFormatter],
  data() {
    return {
      customer: {
        customer_number: '',
        name: '',
        address: '',
        postal: '',
        phone: '',
        fax: '',
        email: ''
      }
    }
  },
  methods: {
    ...mapActions({
      fetchCustomerDetails: "Api/Customers/get",
      addCustomer: "Api/Customers/add"
    }),
    save() {
      this.addCustomer(this.customer)
          .then(result => this.$router.back())
          .catch(this.apiErrorHandler)
    },
    cancel() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>

</style>
